<template>
  <MultiFileDirectUploader
    :accept="accept"
    :on-file-uploaded="onFileUploaded"
    :on-file-removed="onFileRemoved"
    :on-file-upload-progress="onFileUploadProgress"
  >
    <div class="sf-grid sf-pad-3 sf-layer-border sf-border-snow sf-dropzone">
      <div class="sf-row">
        <div class="sf-col sf-alignc">
          <span class="fa fa-cloud-upload sf-icon-large" />
        </div>
      </div>
      <div class="sf-row">
        <div
          v-dompurify-html="
            I18n.t('components.document.dropzone_html', {
              href: `<a>${I18n.t('components.document.browse')}</a>`,
            })
          "
          class="sf-col sf-alignc sf-pad-t-0"
        />
      </div>
    </div>
  </MultiFileDirectUploader>
</template>

<script>
import MultiFileDirectUploader from '@app/shared/vue/components/direct-upload/multi-file-direct-uploader'

export default {
  name: 'TextPropertyFilesUploader',

  components: {
    MultiFileDirectUploader,
  },

  props: {
    accept: {
      type: String,
      required: false,
      default: '',
    },
    onFileUploaded: {
      type: Function,
      required: false,
      default: () => {},
    },
    onFileRemoved: {
      type: Function,
      required: false,
      default: () => {},
    },
    onFileUploadProgress: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
}
</script>
